import { AxiosError } from 'axios';

import { FunusCustomError } from 'config/apiErrors/FunusCustomError';

export class RequiredPDFTypeIAError extends FunusCustomError {
  constructor(error: AxiosError) {
    super(error);
    this.message = 'error.ia.pdfrequired';
    this.name = 'RequiredPDFTypeIAError';
  }
}
